module.exports = __webpack_public_path__ + "static/media/blog6_big.59e47bef.png";